var storefrontApp = angular.module('storefrontApp');
storefrontApp.controller("SpecialsController",
    ["$interval", "$scope", "$window", "specialsService","homeService","commonService","helperService", "loaderService", "storageFactory",
    function ($interval, $scope, $window, specialsService, homeService,commonService, helperService, loaderService, storageFactory) {

        //#region Variables

        var today = new Date();
        var permSaleDate = new Date(today.getFullYear() + 2, today.getMonth(), today.getDay());

        //#endregion

        //#region sales
        $scope.getSalesData = function(){
            specialsService.getActiveSales(false).then(
                function (response) {
                    if(response && response.data){
                        $scope.sales = response.data;
                        if(response.data && response.data.length > 2){
                            var sales = response.data.filter(function(sale){
                                return (angular.isDefined(sale.saleUrl) && sale.saleUrl != '');
                            });
                            sales = sales.sort(function(a,b){
                                return new Date(b.endDate) - new Date(a.endDate);
                            });
                            $scope.ads_data = sales.slice(Math.max(sales.length - 4, 0));
                            $scope.activeAdId = $scope.ads_data[0].id;
                        }
                    }
                }
            );
        }
        //#endregion

        //#region Helper Functions
        $scope.showPinnacleRewardsOnSpecialsPage = function () {
            var pinnacleSettings =
                $window.__env && $window.__env.pinnacleSectionSettings;
            if (!pinnacleSettings) {
                return true;
            }
            return pinnacleSettings.specialsPage !== false;
        };

        $scope.onAdClick = function(data){
            $scope.activeAdId = data.id;
        };

        $scope.isPermanentSale = function(endDate){
            return new Date(endDate) > permSaleDate;
        }
        // #endregion

        //#region Main Ads
        $scope.getMainAds = function() {
            loaderService.show();
            homeService.getMainAds().then(
                function (response) {
                    if (response) {
                        $scope.mainAds = response.data;
                        if (angular.isDefined(response.data) && response.data.length > 0) {
                            $scope.activeMainAdIndex = 0;
                            storageFactory.set("mainAds", JSON.stringify(response.data), true);
                            loaderService.hide();
                        }
                    }
                }
            )
        }

        //#region Banner Ads
        $scope.getSpecialPageContent = function() {
            commonService.getSplPageAds().then(
                function (response) {
                    if (response) {
                        $scope.firstSetAds = response.data.bannerAds;
                       var randomAd = Math.floor(Math.random() * response.data.specialAds.length);
                        $scope.selectedSpecialAd=response.data.specialAds[randomAd];
                        $scope.specialsBanner=$scope.firstSetAds.concat($scope.selectedSpecialAd);
                        if (angular.isDefined( $scope.specialsBanner) &&  $scope.specialsBanner.length > 0) {
                            storageFactory.set("specialsBanner", JSON.stringify($scope.specialsBanner), true);
                        }
                    }
                }
            )
        }

        //#region Carousal Timer and Nav click related
        $scope.carousalTimerFn = function () {
            $scope.onCarousalNavClick(1);
        }
        $scope.carousalInterval = $interval($scope.carousalTimerFn, 5000);
        $scope.onCarousalNavClick = function (val) {
            $interval.cancel($scope.carousalInterval);
            if ($scope.mainAds && $scope.mainAds.length > 0) {
                if (!(($scope.mainAds.length - 1 == $scope.activeMainAdIndex && Number(val) > 0) || ($scope.activeMainAdIndex == 0 && Number(val) < 0))) {
                    $scope.activeMainAdIndex = Number($scope.activeMainAdIndex) + Number(val);
                }
                else {
                    $scope.activeMainAdIndex = 0;
                }
            }
            $scope.carousalInterval = $interval($scope.carousalTimerFn, 5000);
        }
        //#endregion
        //#endregion

        // #region Reset Cache
        $scope.getResetCacheState = function () {
            $scope.resetCache = false;
            var mainAds = helperService.getContent(storageFactory.get("mainAds"));
            if (mainAds == null || $scope.resetCache) {
                $scope.getMainAds();
            }
            else {
                $scope.mainAds = JSON.parse(mainAds);
                if ($scope.mainAds.length > 0) {
                    $scope.activeMainAdIndex = 0;
                }
            }
        }
        //#endregion

        $scope.initialize = function () {
            $scope.getSalesData();
            $scope.getSpecialPageContent();
            $scope.getResetCacheState();

        }
    }
]);
